import { motion } from 'framer-motion';

const BootScreen = ({ progress }) => {
  const clamped = Math.max(0, Math.min(100, progress ?? 0));

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black font-os select-none">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="flex h-20 w-20 items-center justify-center rounded-2xl border border-white/10 bg-white/5 shadow-[0_4px_30px_rgba(255,255,255,0.06)]"
      >
        <span className="text-2xl font-semibold tracking-wide text-white">ST</span>
      </motion.div>

      <div className="mt-10 w-56">
        <div className="h-[3px] w-full overflow-hidden rounded-full bg-white/10">
          <motion.div
            className="h-full rounded-full bg-white/90"
            initial={{ width: 0 }}
            animate={{ width: `${clamped}%` }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          />
        </div>
      </div>

      <p className="mt-4 text-xs font-medium tracking-wide text-white/50">
        Starting up…
      </p>
    </div>
  );
};

export default BootScreen;
